// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__1JSnM"};